import { Layout } from "antd";
import LayoutSidebar from "./sidebar";
import LayoutHeader from "./header";
import LayoutBody from "./body";

export default function MainLayout() {
  return (
    <Layout>
      <LayoutSidebar />
      <Layout>
        <LayoutHeader />

        <LayoutBody />
      </Layout>
    </Layout>
  );
}
